<template>
  <div class="workOrder">
    <div class="container">
      <div class="order_detail">
        <div class="order_detail-box">
          <div class="order_detail-title">工单咨询详情<span v-if="showInfo.orderState === 3" class="order_detail-span">(该工单已关闭，不支持回复，谢谢)</span></div>
        <div class="replay_title">回复工单</div>
        </div>
        <div class="order_detail-box">
          <div class="order_detail-info">
            <div class="text_item"><span>工单id: </span>{{showInfo.userRepairOrderId}}</div>
            <div class="text_item"><span>工单标题:</span> {{showInfo.orderTitle}}</div>
            <div class="text_item"><span>工单内容:</span> {{showInfo.orderContent}}</div>
            <div class="text_item"><span>工单创建时间:</span> {{showInfo.createtime}}</div>
            <div class="text_item"><span>工单更新时间:</span> {{showInfo.updatetime || '暂无'}}</div>
            <!-- <div class="text_item"><span>工单创建人id: </span>{{showInfo.createBy}}</div> -->
            <!-- <div class="text_item"><span>工单创建人名称:</span> {{showInfo.customerName}}</div> -->
            <div class="text_item"><span>工单处理人名称:</span> {{showInfo.fullname || '暂无'}}</div>
            <div class="text_item"><span>工单状态:</span> {{stateMap[showInfo.orderState]}}</div>
          </div>
          <div class="order_detail-info">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item class="orderInput" label="回复内容" prop="replyContent">
                <el-input :disabled="showInfo.orderState === 3 ? true : false" type="textarea" :rows="6" v-model="ruleForm.replyContent" placeholder="请输入回复内容"></el-input>
              </el-form-item>
            </el-form>
            <div class="button_post">
              <el-button type="primary" :disabled="showInfo.orderState === 3 ? true : false" @click="submitForm('ruleForm')">立即回复</el-button>
            </div>
          </div>
        </div>
        <div class="order_detail-title order_reply">工单回复详情</div>
        <el-table :data="replyList" style="width: 100%" class="order_table">
          <!-- <el-table-column prop="userRepairOrderId" label="工单id" align="center"></el-table-column> -->
          <!-- <el-table-column prop="userRepairReplyId" label="工单回复id" align="center" width="120"></el-table-column> -->
          <el-table-column label="回复人名称" align="center">
            <template slot-scope="scope">{{scope.row.userRepairReplyName || '我'}}</template>
          </el-table-column>
          <el-table-column prop="replyContent" label="回复内容" align="center" width="300"></el-table-column>
          <!-- <el-table-column prop="createBy" label="回复人id" align="center"></el-table-column> -->
          <el-table-column prop="createtime" label="回复时间" align="center"></el-table-column>
          <el-table-column label="操作" align="center" min-width="40">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="text" size="small">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            v-if="replyList.length > 0"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="10"
            layout="total, prev, pager, next"
            :total="totalCount">
          </el-pagination>
        </div>
      </div>
      <el-dialog title="工单回复详情" :visible.sync="dialogTableVisible">
        <!-- <div class="replay_text_item"><span>工单id: </span>{{replayForm.userRepairOrderId}}</div> -->
        <!-- <div class="replay_text_item"><span>工单回复id:</span> {{replayForm.userRepairReplyId}}</div> -->
        <!-- <div class="replay_text_item"><span>回复类型:</span> {{replyTypeMap[replayForm.replyType]}}</div> -->
        <div class="replay_text_item"><span>回复人名称:</span> {{replayForm.userRepairReplyName || '我'}}</div>
        <div class="replay_text_item"><span>回复内容:</span> {{replayForm.replyContent}}</div>
        <!-- <div class="replay_text_item"><span>回复人id:</span> {{replayForm.createBy}}</div> -->
        <div class="replay_text_item"><span>回复时间: </span>{{replayForm.createtime}}</div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import * as types from "../../vuex/types";
import workApi from "../../api/work";

export default {
  data() {
    return {
      showInfo: {},
      stateMap: {
        1: "待处理",
        2: "已处理",
        3: "已关闭",
      },
      ruleForm: {
        replyContent: ""
      },
      rules: {
        replyContent: [{ 
          required: true, 
          trigger: "blur",
          validator: (rule, value, callback) => {
            if (_.trim(value) === '') {
                callback(new Error('请输入回复内容'));
              } else if (value.length >= 140) {
                callback(new Error('回复内容最多输入140个字符！'));
              } else {
                callback();
              }
            }
          }]
      },
      replyList: [],
      replyTypeMap: {
        1: "客户端用户回复",
        2: "管理端回复"
      },
      totalCount: 0,
      currentPage: 1,
      formSearch: {
        pageNum: 1,
        pageSize: 10
      },
      dialogTableVisible: false,
      replayForm: {}
    };
  },
  created() {
    let id = this.$route.query.userRepairOrderId
    this.userRepairOrderId = this.$route.query.userRepairOrderId
    this.myDetails(id)
    this.myReplayList(id)
  },
  methods: {
    // 获取我的工单详情
    myDetails(id) {
      workApi.myUserRepairOrderDetails({
        tokenId: localStorage.getItem("dl_tokenId_bl"),
        userRepairOrderId: id
      }).then(res => {
        if (res.code === 0) {
          this.showInfo = res.result
        } else {
          this.setFailMessage({
            show: true,
            content: res.msg || "获取失败"
          });
        }
      }).catch(err => {
        this.setFailMessage({
          show: true,
          content: err.msg || "获取失败"
        });
        console.log("err", err);
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.formSearch.pageNum = val
      this.myReplayList(this.userRepairOrderId)
    },
    // 获取我的工单回复
    myReplayList(id) {
      workApi.myUserRepairReplyList({
        tokenId: localStorage.getItem("dl_tokenId_bl"),
        userRepairOrderId: id,
        ...this.formSearch
      }).then(res => {
        if (res.code === 0) {
          this.replyList = res.result.content
          this.totalCount = parseFloat(res.result.totalElements)
        } else {
          this.setFailMessage({
            show: true,
            content: res.msg || "获取失败"
          });
        }
      }).catch(err => {
        this.setFailMessage({
          show: true,
          content: err.msg || "获取失败"
        });
        console.log("err", err);
      });
    },
    //回复工单
    addUserReplyContent() {
      workApi.addUserReplyContent({
        userRepairOrderId: this.userRepairOrderId,
        ...this.ruleForm
      }).then(res => {
        if (res.code === 0) {
          this.setSuccessModal({
            show: true,
            content: res.msg || "回复成功"
          });
          setTimeout(() => {
            window.location.reload()
          }, 500)
        } else {
          this.setFailMessage({
            show: true,
            content: res.msg || "回复失败"
          });
        }
      }).catch(err => {
        this.setFailMessage({
          show: true,
          content: err.msg || "回复失败"
        });
        console.log("err", err);
      });
    },
    ...mapActions({
      getLoanAllData: types.GET_LOAN_ALL_DATA,
      signAture: types.SIGN_AGREEMENT,
      downContract: types.DOWN_AGREEMENT,
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setFailMessage: types.SET_FAIL_MESSAGE
    }),
    ...mapMutations({
      setLoanAllData: types.SET_LOAN_ALL_DATA,
      setSuccessModal: types.SET_SUCCESS_MESSAGE_STATE,
      setFailModal: types.SET_FAIL_MESSAGE_STATE,
      setSigned: types.SET_SIGNED
    }),
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.addUserReplyContent()
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClick(val) {
      this.dialogTableVisible = true
      this.replayForm = val
    }
  }
};
</script>

<style lang="scss">
.order_detail-title {
  margin-bottom: 15px;
  font-size: 16px;
  width: 50%;
}
.order_detail-span{
  font-size: 14px;
  color: red;
  margin-left: 15px;
}
.order_detail-box {
  display: flex;
  justify-content: space-between;
}
.order_detail-info {
  width: 45%;
  padding: 15px 15px 7px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  .text_item {
    font-size: 14px;
    color: #333;
    margin-bottom: 8px;
    line-height: 24px;
    display: flex;
    word-break: break-word;
  }
  .text_item span{
    margin-right: 20px;
    min-width: 100px;
    display: inline-block;
  }
}
.order_reply {
  margin-top: 30px;
}
.button_post {
  padding-top: 15px;
  margin-left: 100px;
}
.orderInput {
  height: initial !important;
}
.replay_title {
  width: 50%;
  padding: 5px 0 20px;
  font-size: 15px;
  margin-left: 30px;
}
.replay_text_item{
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
  line-height: 24px;
  display: flex;
  word-break: break-word;
}
.replay_text_item span{
  margin-right: 20px;
  min-width: 100px;
  display: inline-block;
}
.order_detail-info .el-form-item__label{
  width: 80px !important;
}
</style>


// WEBPACK FOOTER //
// workOrderDetails.vue?69f3d5f2